import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../../utils';
import { className, isMobile } from 'soluble-design-system-base';
import { Heading, Text } from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';
import Container from '../../componentsV2/Container';
import style from './style.module.scss';

const stagger = {
    hidden: {},
    visible: {
        transition: { staggerChildren: 0.25, delayChildren: 0.8 },
    },
};

export default function HeroSectionVideo(props) {
    const buttonRef = React.useRef();
    return (
        <section id="gradientVideo" className={style.gradient} aria-labelledby={props.id}>
            <Container
                backgroundImage={props.posterDesktop ? props.posterDesktop.url : null}
                backgroundImageWide={props.posterDesktopFullWidth ? props.posterDesktopFullWidth.url : null}
                backgroundImageMobile={props.posterMobile ? props.posterMobile.url : null}
                backgroundClassName={`${style.background}`}
                containerCpm={`${style.containerCpm}`}
                video={{
                    src: props.videoHero,
                }}
                areaVideoCursorClassName={`${style.areaVideoCursor}`}
                {...props}
            >
                <motion.div
                    id="heroVideoText"
                    variants={stagger}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ amount: 0.8, once: true }}
                    {...className(`${style.wrapper}`)}
                >
                    <div className={style.container}>
                        <Heading framer={1} tag={props.titleTag} id={props.id}>
                            {props.title}
                        </Heading>

                        <motion.div variants={fadeInUp}>
                            <p>{props.text}</p>
                        </motion.div>
                    </div>
                    <motion.div
                        variants={fadeInUp}
                        {...className(`${style.buttons}`)}
                    >
                        {props.buttons && props.buttons.length ? (
                            <div ref={buttonRef}>
                                <ButtonComponent
                                    buttons={props.buttons}
                                    blockMobile={true}
                                    dark={false}
                                    buttonClassName={`${style['first-button']}`}
                                />
                            </div>
                        ) : null}
                    </motion.div>
                </motion.div>
            </Container>
        </section>
    );
}
